var UTILS = {
    months: {
        pt: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ],
        en: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        fr: [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Août',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre'
        ]
    },
    mapsArray: [],
    init: function () {
        UTILS.checkMobileDevice();
        UTILS.initGoogleMaps();
        UTILS.addTargetExternalLinks();
        UTILS.initCookieInfo();
    },
    trim: function (str) {
        var str = str.replace(/^\s\s*/, ''),
            ws = /\s/,
            i = str.length;
        while (ws.test(str.charAt(--i))) ;
        return str.slice(0, i + 1);
    },
    pad: function (str, max, left) {
        str = str.toString();
        if (left) return str.length < max ? this.pad('0' + str, max, left) : str;
        else return str.length < max ? this.pad(str + '0', max, left) : str;
    },
    validateNIF: function (contribuinte) {
        const nif = typeof contribuinte === 'string' ? contribuinte : contribuinte.toString();

        const validationSets = {
            one: ['1', '2', '3', '5', '6', '8'],
            two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99']
        };

        if (nif.length !== 9) return false;

        if (!validationSets.one.includes(nif.substring(0, 1)) && !validationSets.two.includes(nif.substring(0, 2))) return false;

        const total = nif[0] * 9 + nif[1] * 8 + nif[2] * 7 + nif[3] * 6 + nif[4] * 5 + nif[5] * 4 + nif[6] * 3 + nif[7] * 2;

        const modulo11 = (Number(total) % 11);

        const checkDigit = modulo11 < 2 ? 0 : 11 - modulo11;
        return checkDigit === Number(nif[8]);

    },
    formatDate: function (date) {
        var year = date.getFullYear();
        var month = UTILS.pad(date.getMonth() + 1, 2, true);
        var day = UTILS.pad(date.getDate(), 2, true);
        return year + '-' + month + '-' + day;
    },
    formatDateHuman: function (date) {
        var year = date.getFullYear();
        var month = UTILS.months['pt'][date.getMonth()];
        var day = UTILS.pad(date.getDate(), 2, true);
        return day + ' ' + month + ', ' + year;
    },
    parseYoutubeURL: function (url) {
        var regExp = /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:(?:watch)?\?(?:.*&)?v(?:i)?=|(?:embed|v|vi|user)\/))([^\?&\"'>]+)/;
        var match = url.match(regExp);
        if (match) {
            return match[1];
        } else {
            return '';
        }
    },
    parseVimeoURL: function (url) {
        var regExp = /http(?:s)?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
        var match = url.match(regExp);

        if (match) {
            return match[2];
        } else {
            return '';
        }
    },
    blockUI: function (flag) {
        if (flag) {
            $('html').css('pointer-events', 'none');
            $('html').css('cursor', 'wait');
        } else {
            $('html').css('pointer-events', 'auto');
            $('html').css('cursor', 'auto');
        }
    },
    checkMobileDevice: function () {
        var ua = navigator.userAgent;
        var iPhoneDevice = ua.toLowerCase().indexOf('iphone') != -1;
        var iPadDevice = ua.toLowerCase().indexOf('ipad') != -1;
        var windowsPhoneDevice = ua.toLowerCase().indexOf('windows phone') != -1;
        var androidDevice = /Android/.test(ua);

        if (iPhoneDevice || iPadDevice || windowsPhoneDevice || androidDevice) {
            $('#app').addClass('mobile-device');
        } else {
            $('#app').addClass('desktop-device');
        }
    },
    addTargetExternalLinks: function () {
        $('a[href^="http"]')
            .not('a[href*="' + location.hostname + '"]')
            .attr({target: '_blank', rel: 'noopener'});
    },
    // Google Maps
    initGoogleMaps: function () {
        var maps = $('.gmap');
        var key = $('#app').attr('data-google-key');

        console.log(maps.length);
        if (maps.length > 0) {
            $.getScript(
                'https://maps.googleapis.com/maps/api/js?v=quarterly&key=' +
                key +
                '&callback=UTILS.configureGoogleMaps'
            );
        }
    },

    configureGoogleMaps: function () {
        var maps = $('.gmap');
        UTILS.mapsArray = [];
        for (var i = 0; i < maps.length; i++) {
            var mapInfo = $(maps[i]);
            var mapOptions = {
                zoom: Number(mapInfo.attr('data-zoom')),
                center: new google.maps.LatLng(
                    mapInfo.attr('data-lat'),
                    mapInfo.attr('data-lon')
                ),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false
            };

            var map = new google.maps.Map($(maps[i])[0], mapOptions);
            /* skin the map with this
            var styles = [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"},{"lightness":33}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2e5d4"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#c5dac6"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":20}]},{"featureType":"road","elementType":"all","stylers":[{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#c5c6c6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#e4d7c6"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#fbfaf7"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#acbcc9"}]}];
            map.setOptions({styles: styles}); */

            /* add a simple or advanced image (with retina size and anchor point)
                  var image = '/images/aju.png';
                  var image = new google.maps.MarkerImage(
                                   // URL
                                   '/images/gmaps-marker1.png',
                                   // original image size
                                   new google.maps.Size(180, 165),
                                   // origin point (x,y)
                                   new google.maps.Point(0, 0),
                                   // anchor point (x,y)
                                   new google.maps.Point(91, 82),
                                   // scaled size
                                   new google.maps.Size(91, 82)
                                  );*/

            var data_points = mapInfo.attr('data-points').split('#');
            for (var j = 0; j < data_points.length; j++) {
                var latlon = data_points[j].split(';');

                var myLatLng = new google.maps.LatLng(latlon[0], latlon[1]);
                var beachMarker = new google.maps.Marker({
                    position: myLatLng,
                    map: map /*,
              icon: image, //we can have spec icon
              title: latlon[2] */ //hover title if we want..
                });
            }

            UTILS.mapsArray.push(map);
        }

        google.maps.event.addDomListener(window, 'resize', UTILS.resizeGoogleMaps);
    },

    resizeGoogleMaps: function () {
        for (var i = 0; i < UTILS.mapsArray.length; i++) {
            var map = UTILS.mapsArray[i];
            var center = map.getCenter();
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
        }
    },

    cleanDelegate: function (target, method, args) {
        return typeof method == 'function'
            ? function () {
                /* Start with no arguments */
                var arguments_array = [];

                /* Push additional arguments */
                for (var arg in args) {
                    if (args.hasOwnProperty(arg)) arguments_array.push(args[arg]);
                }
                return method.apply(target, arguments_array);
            }
            : function () {
                return false;
            };
    },

    slideTo: function (selector, offset) {
        if (offset == undefined) offset = 0;

        console.log(selector);
        $('html, body').animate(
            {
                scrollTop: $(selector).offset().top + offset
            },
            1000
        );
    },
    getUrlVars: function () {
        var vars = {};
        var parts = window.location.href.replace(
            /[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                vars[key] = value;
            }
        );
        return vars;
    },
    cookie_name: 'CookieConsent',
    initCookieInfo: function () {
        // check if cookie was already accepted
        var show_cookie_info = !document.cookie.match(
            new RegExp(APP.cookie_name + '=([^;]+)')
        );
        if (show_cookie_info) {
            $('#cookies-info').show();
            $('#cookies-info-accept').click(function (ev) {
                UTILS.acceptCookieInfo(ev.originalEvent);
            });
        } else {
            $('#cookies-info').remove();
        }
    },
    acceptCookieInfo: function (e) {
        // set the cookie expiry to one year after today.
        var expiryDate = new Date();
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        document.cookie =
            APP.cookie_name + '=y; path=/; expires=' + expiryDate.toGMTString();
        $('#cookies-info').fadeOut(250);
        e.stopPropagation && e.stopPropagation();
        e.cancelBubble = true;
        return false;
    }
};
